module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/street-duo.36727bfc.png";